import { Container, Grid, makeStyles, createMuiTheme, ThemeProvider } from '@material-ui/core'
import PointCloudCard from '../components/PointCloudCard';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import logo from '../static/logo.png'; // Tell webpack this JS file uses this image
import React from 'react'
import pointcloudMetadata from '../studentData';
import {useHistory} from 'react-router-dom'


const theme = createMuiTheme(
  {
    palette: {
      type: 'dark',
    }
  },
);

const useStyles = makeStyles({
  root: {
    fontFamily: 'Gotham',
    [theme.breakpoints.down('md')]: {
      height: 'fit-content',
      padding: '15px',
      paddingTop: '1%',
      display: 'inline-block'
    },
    [`${theme.breakpoints.down('md')} and (orientation: landscape)`]: {
      height: '100%',
      display: 'flex'
    },
    height: '100vh',
    alignContent: 'center',
    display: 'flex'
  },
  logo: {
    [theme.breakpoints.down('md')]: {
      height: '50px',
      position: 'unset', 
      alignSelf: 'center',
      display: 'inline-block',
      margin: '5% 5% 4% 5%',
    },

    position: 'fixed', 
    zIndex: 2, 
    margin: '20px',
    height: '20%',
    maxHeight: '100px'
  },
  logoImg: {
    [theme.breakpoints.down('md')]: {
      maxHeight: '100%',
    },
    maxHeight: '100%',
    height: '100%'
  },
  grid: {
    [`${theme.breakpoints.down('md')} and (orientation: landscape)`]: {
      // flexDirection: 'column'
      height: '100%',
      display: 'flex'
    },
    alignSelf: 'center'
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
})

const PointCloudCardGrid = (props) => {
  const matches = useMediaQuery(`${theme.breakpoints.down('md')} and (orientation: landscape)`);
  const {imageUrl, name, onClick} = props;
  console.log(imageUrl);

  return (
    <Grid item xs={(matches) ? 3 : 6} md={4} onClick={onClick}>
      <PointCloudCard unit={name} imageUrl={imageUrl} />
    </Grid>
  );
}

export default function WelcomePage () {
  const classes = useStyles();

  const history = useHistory();
  const goToCloud = (id) => history.push(`/unit/${id}`);

  return (
    <ThemeProvider theme={theme}>
      <div className={classes.logo}>
        <img className={classes.logoImg} src={logo} alt="Logo" />
      </div> 
      <Container className={classes.root} maxWidth="md">
        <Grid 
          container 
          spacing={1}
          className={classes.grid}
        >
          {pointcloudMetadata.units.map((meta) => {
            return (
                <PointCloudCardGrid 
                  key={meta.name} 
                  imageUrl={meta.image} 
                  name={meta.name}
                  onClick={() => {goToCloud(meta.id)}}
                />
            )
          })}
        </Grid>
      </Container>
    </ThemeProvider>
  )
}